import { useEffect, useState } from "react"


const ACCESS_STORAGE_KEY = 'ea11y-global-state'


const triggerStorageEventInSameWindow = () => {
    const origSetItem = window.localStorage.setItem

    window.localStorage.setItem = function setItem(key, value) {
        let oldValue = window.localStorage.getItem(key);
    
        const result = origSetItem.apply(this, arguments);
    
        const e = new StorageEvent('storage', {
            storageArea: window.localStorage,
            key,
            oldValue,
            newValue: value,
            url: window.location.href,
        })

        window.dispatchEvent(e)
    
        return result
    }
}


const checkAcccessSettings = ()  => {
    const item = JSON.parse(window.localStorage.getItem(ACCESS_STORAGE_KEY))

    return item && item.hasOwnProperty('activeTools') && Object.keys(item.activeTools).length > 0
}

export const useCheckAccess = () => {
    triggerStorageEventInSameWindow()

    const [useAccesTheme, setUseAccesTheme] = useState(checkAcccessSettings())

    useEffect(() => {
        const handleChange = event => {
            if(ACCESS_STORAGE_KEY  === event.key) {
                const check = checkAcccessSettings()
                setUseAccesTheme(check)  
            }
        }

        window.addEventListener('storage', handleChange)

        return () => {
            window.removeEventListener('storage', handleChange)
        }
    }, [])

    return useAccesTheme
}